<template>
    <b-table
        ref="table"
        :data="logsUrls"
        borderless
        striped
        hoverable>

      <b-table-column field="platform" label="Platform" v-slot="props">
        {{ props.row.platform }}
      </b-table-column>

      <b-table-column field="ci_service_url" label="CI Link" v-slot="props">
        <p v-if="!props.row.ci_service_url"> No CI link </p>
        <a v-else :href="props.row.ci_service_url"
          target="_blank">
          {{ props.row.ci_service || "Open CI" }}
        </a>
      </b-table-column>

      <b-table-column field="logs_url" label="Log link" v-slot="props">
        <a :href="props.row.logs_url" target="_blank"> Open logs </a>
      </b-table-column>

      <template #empty>
        <div class="has-text-centered">No links found for this MTR</div>
      </template>

    </b-table>
</template>

<script>
    export default {
        name: "LogsLinksTable",
        props: {
            logsUrls: Array,
        }
    }
</script>
